module.exports = __webpack_public_path__ + "img/ledger.68e266f4.svg";